'use client';

import { useEffect, useLayoutEffect } from 'react';

/**
 * `useLayoutEffect` in the browser, `useEffect` on the server. React warns when
 * a layout effect runs during server rendering, since there is no DOM to lay
 * out, so the hook picks the one that fits where it runs. Use it for effects
 * that measure or position elements: the browser keeps them synchronous, before
 * the first paint, so nothing flashes at its unmeasured size.
 */
export const useIsomorphicLayoutEffect =
  typeof window !== 'undefined' ? useLayoutEffect : useEffect;
